module.exports = __webpack_public_path__ + "img/mobilepartyterminal1.17ad3359.png";